import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], total: 0, count: 0 });
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) {
      setCart({ items: [], total: 0, count: 0 });
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.get("/cart");
      setCart(data);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (product_id, quantity = 1) => {
    const { data } = await api.post("/cart/add", { product_id, quantity });
    setCart(data);
  };
  const update = async (product_id, quantity) => {
    const { data } = await api.post("/cart/update", { product_id, quantity });
    setCart(data);
  };
  const remove = async (product_id) => {
    const { data } = await api.delete(`/cart/${product_id}`);
    setCart(data);
  };

  return (
    <CartCtx.Provider value={{ cart, loading, add, update, remove, refresh }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
